<template>
  <v-app v-resize="onResize">
    <v-app-bar dense dark fixed app color="brown darken-1" v-if="$store.state.auth.user && $store.state.auth.settings.terms">
      <v-toolbar-title class="hidden-xs-only" v-if="!$store.state.auth.employee">
        <span v-if="$store.state.clientID" style="display: inline-block">
          <v-icon v-if="$store.state.websocket.isConnected" large color="green">{{ mdiCloudCheck }}</v-icon>
          <v-icon v-else large color="red">{{ mdiCloudAlert }}</v-icon>
        </span>
        <span v-if="$store.state.clientID" style="display: inline-block; min-width: 10px" />
        <span v-if="$store.state.websocket.serverTimeReceived" class="headline" style="display: inline-block">
          {{ formatDate($store.state.websocket.serverTime, $store.state.auth.df.time) }}
        </span>
        <span style="display: inline-block; min-width: 10px" />
        <span class="title" style="display: inline-block">{{ $store.state.auth.wPlaceSettings.name }}</span>
        <span style="display: inline-block; min-width: 15px"></span>
        <span class="title" style="display: inline-block">{{ $store.state.auth.fullName }}</span>
      </v-toolbar-title>
      <v-toolbar-title class="hidden-xs-only" v-else>
        <span class="title" style="display: inline-block">{{ $store.state.auth.fullName }}</span>
      </v-toolbar-title>

      <v-spacer />

      <v-toolbar-items>
        <v-btn v-if="$store.state.auth.employee" text to="/employee">
          <v-icon large>{{ mdiHomeEdit }}</v-icon>
          <span style="width: 10px" />
          <span class="hidden-xs-only">{{ $t('label.visitsOverview') }}</span>
        </v-btn>

        <v-btn class="hidden-xs-only" v-if="$store.state.auth.wPlaceSettings.name && !$store.state.auth.employee" text to="/workplace">
          <v-icon large class="mr-1">{{ mdiHomeEdit }}</v-icon>
          {{ $tc('label.workplace') }}
        </v-btn>

        <v-btn
          class="hidden-xs-only"
          v-if="$store.state.auth.userSettings.accArchive.read && !$store.state.auth.employee"
          text
          to="/archive"
        >
          <v-icon large class="mr-1">{{ mdiArchive }}</v-icon>
          {{ $tc('label.archive') }}
        </v-btn>
        <v-btn v-if="!$store.state.auth.employee && accessSettings()" text to="/settings">
          <v-icon large>{{ mdiCog }}</v-icon>
          <span style="width: 10px" />
          <span class="hidden-xs-only">{{ $tc('label.settings') }}</span>
        </v-btn>

        <v-menu bottom offset-y transition="slide-y-transition">
          <template v-slot:activator="{ on }">
            <v-btn text v-on="on"
              ><v-icon large>{{ mdiMenu }}</v-icon></v-btn
            >
          </template>
          <v-list>
            <v-list-item @click="dialogUserSettings = true" text>
              <v-list-item-icon large>
                <v-icon>{{ mdiAccount }}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ $tc('label.settingsUser') }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item @click="openHelp" text>
              <v-list-item-icon large
                ><v-icon>{{ mdiHelpCircle }}</v-icon></v-list-item-icon
              >
              <v-list-item-content>
                <v-list-item-title>{{ $tc('label.help') }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item @click="logout" text>
              <v-list-item-icon large
                ><v-icon>{{ mdiLogout }}</v-icon></v-list-item-icon
              >
              <v-list-item-content>
                <v-list-item-title>{{ $tc('label.logout') }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <hr />
          <v-list>
            <v-list-item @click="dialogAbout = true" text>
              <v-list-item-icon large>
                <v-icon>{{ mdiInformation }}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ $tc('label.about') }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-toolbar-items>
    </v-app-bar>

    <v-main>
      <router-view />
    </v-main>

    <v-dialog v-model="dialogError" max-width="65vw">
      <v-card>
        <v-card-title class="headline red lighten-1" primary-title>{{ $tc('label.error') }}</v-card-title>
        <v-card-text>
          <v-sheet width="100%" style="overflow: auto">
            <br />
            <h3>{{ errorHeader }}</h3>
            <pre v-if="dialogErrorDetail">{{ errorText }}</pre>
          </v-sheet>
        </v-card-text>
        <v-card-actions>
          <v-btn v-if="showErrorDetail" @click="dialogErrorDetail = !dialogErrorDetail">{{ $tc('btn.detail') }}</v-btn>
          <v-spacer />
          <v-btn color="red lighten-1" @click="((dialogError = false), (dialogErrorDetail = false))">{{ $tc('btn.close') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogUserSettings" persistent max-width="60vw">
      <v-card>
        <v-card-title class="headline colorHeadlineStandard" primary-title>
          {{ $tc('label.settingsUser') }}
          <v-spacer />
          <v-icon large @click="dialogUserSettings = false">{{ mdiClose }}</v-icon>
        </v-card-title>
        <v-card-text>
          <SettingsUser />
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogAbout" max-width="60vw">
      <v-card>
        <v-card-title class="headline colorHeadlineStandard" primary-title>
          {{ $t('label.about') }} Portunus
          <v-spacer />
          <v-icon large @click="dialogAbout = false">{{ mdiClose }}</v-icon>
        </v-card-title>
        <v-card-text>
          <About />
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="errSnack" :timeout="3500" top color="red">{{ errMsg }}</v-snackbar>
  </v-app>
</template>

<script lang="ts">
import Vue from 'vue';
import axios from 'axios';
import VueMoment from 'vue-moment';
import moment from 'moment-timezone';
import SettingsUser from '@/components/settings/User.vue';
import About from '@/components/About.vue';

axios.defaults.timeout === 5000;
axios.defaults.withCredentials = true;

import {
  mdiClose,
  mdiCloudAlert,
  mdiCloudCheck,
  mdiHomeEdit,
  mdiArchive,
  mdiCog,
  mdiMenu,
  mdiAccount,
  mdiLogout,
  mdiInformation,
  mdiHelpCircle,
} from '@mdi/js';

// const moment = require('moment');
// require('moment/locale/cs');

Vue.use(VueMoment as any, { moment });

export default Vue.extend({
  name: 'App',
  components: { About, SettingsUser },
  data: () => ({
    dialogAbout: false,
    dialogUserSettings: false,
    dialogError: false,
    dialogErrorDetail: false,
    showErrorDetail: false,
    errorHeader: '',
    errorText: '',
    errSnack: false,
    errMsg: '',
    mdiCloudAlert: mdiCloudAlert,
    mdiCloudCheck: mdiCloudCheck,
    mdiHomeEdit: mdiHomeEdit,
    mdiArchive: mdiArchive,
    mdiCog: mdiCog,
    mdiMenu: mdiMenu,
    mdiAccount: mdiAccount,
    mdiLogout: mdiLogout,
    mdiClose: mdiClose,
    mdiInformation: mdiInformation,
    mdiHelpCircle: mdiHelpCircle,
  }),
  watch: {
    '$store.state.globalMessage'() {
      if (this.$store.state.globalMessage !== '') {
        this.errMsg = this.$store.state.globalMessage;
        this.errSnack = true;
        this.$store.commit('globalMessage', '');
      }
    },
    '$store.state.globalErrorText'() {
      // Ak Err - Vyzaduje kompletny vypis/Neocakavany error
      // TODO: precistit error messaging
      if (typeof this.$store.state.globalErrorText.message === 'string') {
        this.errorHeader = this.$store.state.globalErrorText;
        this.dialogError = true;
        return;
      }
      if (this.$store.state.globalErrorText !== '') {
        if (this.$store.state.globalErrorText.data.message === 'licLimit') {
          switch (this.$store.state.globalErrorText.data.lic) {
            case 'workplaces':
              this.errorHeader = this.$i18n.t('label.licenseLimitExceeded') + ': ' + this.$store.state.globalErrorText.data.value;
              this.showErrorDetail = false;
              break;
            case 'transactions':
              this.errorHeader = this.$i18n.t('label.licenseLimitExceeded') + ': ' + this.$store.state.globalErrorText.data.value;
              this.showErrorDetail = false;
              break;
            default:
              break;
          }
        } else {
          this.errorHeader = this.$store.state.globalErrorText.data.message;
          this.errorText = this.$store.state.globalErrorText;
          this.showErrorDetail = true;
        }
        this.dialogError = true;
        // this.$store.commit('globalErrorText', '');
      }
    },
  },
  created() {
    // Set initial language
    const availibleLocales = this.$i18n.availableLocales;
    const usersLanguage = window.navigator.language;
    if (availibleLocales.includes(usersLanguage)) {
      this.$i18n.locale = usersLanguage;
      this.$vuetify.lang.current = usersLanguage;
      this.$moment.locale(usersLanguage);
    } else {
      this.$i18n.locale = 'en';
      this.$vuetify.lang.current = 'en';
      this.$moment.locale('en');
    }
    // get application settings
    this.getInitSettings();
  },
  mounted() {
    // console.log('Montujem');
    // Ak je definovany tak nastav appMode "electron", ...
    if (this.$route.query.appMode !== undefined) {
      sessionStorage.appMode = this.$route.query.appMode;
    }
    // Ak je definovane tak nastav clientID (pracoviste)
    if (this.$route.query.clientID !== undefined) {
      const clientID: any = this.$route.query.clientID;
      localStorage.setItem('clientID', clientID);
    }
    // Ak je registrovany ako vratnica pust websocket
    if (localStorage.getItem('clientID') === null || localStorage.getItem('clientID') === '') {
      // console.log('login-WITHOUT-Workplace');
      this.$store
        .dispatch('checkLogin')
        .then(() => {
          this.$i18n.locale = this.$store.state.auth.language;
          this.$vuetify.lang.current = this.$store.state.auth.language;
          this.$moment.locale(this.$store.state.auth.language);
          // console.log('vsetko nacitasne');
        })
        .catch((err) => {
          console.log('[err: App_checkLogin-catch]', err);
        });
    } else {
      this.$store.commit('clientID', localStorage.getItem('clientID'));
      this.$store.dispatch('getWorkplaceSettings');
      // console.log('login-WITH-Workplace');
      this.$store
        .dispatch('checkLogin')
        .then(() => {
          this.$i18n.locale = this.$store.state.auth.language;
          this.$vuetify.lang.current = this.$store.state.auth.language;
          this.$moment.locale(this.$store.state.auth.language);
          if (!this.$store.state.auth.employee) {
            this.$store.dispatch('webSocketOpen');
          }
          // console.log('vsetko nacitasne');
        })
        .catch(() => {
          // console.log('[err: App_checkLogin-catch]', err);
        });
    }
    // Automaticke obnovenie user session
    setInterval(() => {
      if (this.$store.state.auth.wPlaceSettings.stayLoggedIn && !this.$store.state.auth.employee) {
        if (this.$store.state.auth.user !== '' && this.$store.state.websocket.isConnected) {
          axios
            .get('/api/v1/refreshsession')
            .then(() => {
              // console.log('sessionOK');
            })
            .catch((err) => {
              console.log('sessionRefreshError');
              this.$store.dispatch('catchErrHandler', err);
            });
        }
      }
    }, 120000);

    this.onResize();
  },
  methods: {
    logout() {
      this.$router.push('/');
    },
    onResize() {
      this.$store.commit('windowSize', {
        x: window.innerWidth,
        y: window.innerHeight,
      });
    },
    getInitSettings() {
      axios
        .get('/api/initsettings')
        .then((response) => {
          axios.defaults.timeout = response.data.httpTimeout;
          this.$store.commit('allowPasswordReset', response.data.allowPasswordReset);
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
        });
    },
    // Open help in popup window
    openHelp() {
      window.open(`${window.location.origin}/help`, '_blank');
    },
    accessSettings() {
      if (
        !this.$store.state.auth.userSettings.accEmployees.read &&
        !this.$store.state.auth.userSettings.accEmployeeGroups.read &&
        !this.$store.state.auth.userSettings.accMessages.read &&
        !this.$store.state.auth.userSettings.accTemplates.read &&
        !this.$store.state.auth.userSettings.accAreas.read &&
        !this.$store.state.auth.userSettings.accVisitors.read &&
        !this.$store.state.auth.userSettings.accCompanies.read &&
        !this.$store.state.auth.userSettings.accCars.read &&
        !this.$store.state.auth.userSettings.accUsers.read &&
        !this.$store.state.auth.userSettings.accCards.read &&
        !this.$store.state.auth.userSettings.accItems.read &&
        !this.$store.state.auth.userSettings.accDocumentTypes.read &&
        !this.$store.state.auth.userSettings.accWorkplaces.read &&
        !this.$store.state.auth.userSettings.accMobileDevices.read &&
        !this.$store.state.auth.userSettings.accSignTerm.read &&
        !this.$store.state.auth.userSettings.accSettings.read
      ) {
        return false;
      } else {
        return true;
      }
    },
    formatDate(date: string, format: string) {
      return this.$moment(date).format(format);
    },
  },
});
</script>

<style>
.tableCursor {
  cursor: context-menu;
}

.tableSelectCursor {
  cursor: pointer;
}

.textCursor {
  cursor: context-menu;
}

.v-tooltip__content.menuable__content__active {
  font-size: 16px !important;
  opacity: 1 !important;
  display: block !important;
  background: rgb(83, 83, 83, 1) !important;
  border-radius: 10px !important;
  padding-top: 10px !important;
  padding-bottom: 10px !important;
}

.thin-scrollbar::-webkit-scrollbar {
  width: 5px;
  height: 8px;
  background-color: rgb(226, 226, 226); /* or add it to the track */
}
.thin-scrollbar::-webkit-scrollbar-thumb {
  background: rgb(92, 92, 92);
}
</style>
